module.exports = __webpack_public_path__ + "img/DiHS_Dashboard_Icon_Guthaben.254559e7.svg";